import { render, staticRenderFns } from "./ListDrag.vue?vue&type=template&id=20dd23fc&"
import script from "./ListDrag.vue?vue&type=script&lang=js&"
export * from "./ListDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports